export interface sortByTable {
    field:string,
    order: orderTable,
    fieldType:fieldType
}

export enum orderTable {
    asc = "asc",
    dsc = "dsc"
}

export enum fieldType {
    string = "string",
    number = "number",
    date = "date"
}